module.exports = __webpack_public_path__ + "img/logout.a4b3a1db.png";